import { render, staticRenderFns } from "./successAuth.vue?vue&type=template&id=9081cab6&scoped=true&"
import script from "./successAuth.vue?vue&type=script&lang=js&"
export * from "./successAuth.vue?vue&type=script&lang=js&"
import style0 from "./successAuth.vue?vue&type=style&index=0&id=9081cab6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9081cab6",
  null
  
)

export default component.exports